<template>
  <div class="group-list-item">
    <div class="meta">
      <router-link v-if="route" :to="route" class="name">{{
        name
      }}</router-link>
      <div v-else class="name">{{ name }}</div>
      <div v-if="showCategoryCount" class="count">
        มีทั้งหมด {{ categoryCount }} category
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: null,
    },
    route: {
      type: [Object, String],
      default: null,
    },
    categoryCount: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    showCategoryCount() {
      return this.categoryCount !== null
        && this.categoryCount !== undefined
        && this.categoryCount !== "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.group-list-item {
  border-bottom: $border;
  padding: ($space / 2) $space;

  > .meta {
    display: block;
  }
}

.meta > .name {
  line-height: 1.6;
  display: inline-block;

  &:hover {
    color: black;
  }
}

.count {
  font-size: 14px;
}
</style>
